export { SelectPipe } from './SelectPipe';
export { ApolloQueryObservable } from './ApolloQueryObservable';
export { CLIENT_MAP, CLIENT_MAP_WRAPPER } from './tokens';
export { Apollo, ApolloBase, provideClientMap } from './Apollo';
export { ApolloModule, defaultApolloClient, APOLLO_PROVIDERS, APOLLO_DIRECTIVES } from './ApolloModule';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-angular/build/src/index.js
// module id = 10
// module chunks = 4